import React from 'react';
import AppDownload from 'MMT-UI/cards/pwaHeaderStrip';
import { SEO_CABS_LANDING_PAGE } from '../constants/templateConstants';

export const AppDownloadBanner = ({
  templateName
}: {
  templateName: string;
}) => {
  return (
    <>
      {templateName == SEO_CABS_LANDING_PAGE ? (
        <div style={{ height: '79px' }} className={`mobileShow makeSticky`}>
          <AppDownload
            heading={'Get App Exclusive Offers'}
            text={
              'Use code WELCOMEMMT to get 8% off on Outstation cabs on your 1st MMT booking'
            }
            buttonText={'INSTALL APP'}
            deepLink={'https://applinks.makemytrip.com/ZRa32I33Lpb'}
          />
        </div>
      ) : null}
    </>
  );
};
